/**
 * for Page in Post Domains
 */
$(function () {
    /**
     * Choose template before create new page
     */
    $('body').on('click', 'a.create-page', function (e) {
        e.preventDefault()
        const pageList = $('#page-templates').data('list')
        const templateList = {
            '': 'None',
            ...pageList
        }

        Swal.fire({
            title: 'Choose page template',
            input: 'select',
            inputOptions: templateList,
            inputValue: 'none',
            showCancelButton: true,
            confirmButtonText: 'Create Page',
            cancelButtonText: 'Cancel'
        }).then(result => {
            if (result.isConfirmed) {
                const q = result.value ? '?template=' + result.value : ''
                window.location.href = window.location.origin + window.location.pathname + '/create' + q
            }
        })
    })
})
